import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <svg width="95.716" height="95.716" viewBox="0 0 95.716 95.716">
    <g id="success" transform="translate(-923.832 -758)">
      <g
        id="Grupo_1658"
        data-name="Grupo 1658"
        transform="translate(947.771 785.635)"
      >
        <rect
          id="Retângulo_460"
          data-name="Retângulo 460"
          width="49"
          height="49"
          transform="translate(-0.583 -0.635)"
          fill="none"
        />
        <path
          id="Checkbox"
          d="M19.062,33.151,0,14.089l3.868-3.868L19.062,25.139,44.2,0l3.868,3.868Z"
          transform="translate(-0.058 5.935)"
          fill="#73f6f9"
        />
      </g>
      <g
        id="Elipse_1"
        data-name="Elipse 1"
        transform="translate(923.832 758)"
        fill="none"
        stroke="#73f6f9"
        strokeWidth="5"
      >
        <ellipse
          cx="47.858"
          cy="47.858"
          rx="47.858"
          ry="47.858"
          stroke="none"
        />
        <ellipse cx="47.858" cy="47.858" rx="45.358" ry="45.358" fill="none" />
      </g>
    </g>
  </svg>,
  'SuccessIcon',
);
